module.exports = __webpack_public_path__ + "static/media/Element_Geo.5343adb3.png";